(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    if (!e.target.classList.contains('qcs-delete')) return;

    if (!confirm('Remove this Enquiry?')) return;

    fetch(window.ajax_callback_data.ajax_url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        action: 'qcs_delete_enquiry',
        id: e.target.dataset.id,
      }),
    }).then(() => location.reload());
  });
})();
